import styled from 'styled-components'

const WrapSpan = styled.span`
  display: flex;
`

const WrapDot = styled.span`
  padding-right: 4px;
`

export { WrapDot, WrapSpan }
